<template>
  <b-card no-body class="cardbody-p rounded-md h-60vh w-full bg-ededed">
    <div class="pm-green px-4 py-2 rounded-t-md ">
      <p class="text-white font-normal text-sm">WEB DEVELOPER</p>
    </div>
    <div class="px-2 mt-4">
      <div class="pm-overflow-y-primary-color cust-maxht">
        <b-card no-body class="p-2 mb-2">
          <p class=" text-xs text-black font-semibold">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
            posuere erat a ante.
          </p>
          <div class="flex justify-between items-center mt-2">
            <b-card
              no-body
              class="bg-default text-white rounded-full py-0 px-2"
            >
              <span class=" cust-badgetext">In Progess</span>
            </b-card>
            <p class=" text-10px font-normal text-mute ">Thursday</p>
          </div>
        </b-card>
        <b-card no-body class="p-2 mb-2">
          <p class=" text-xs text-black font-semibold">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
            posuere erat a ante.
          </p>
          <div class="flex justify-between items-center mt-2">
            <b-card
              no-body
              class="bg-warning text-white rounded-full py-0 px-2"
            >
              <span class=" cust-badgetext">On hold</span>
            </b-card>
            <p class=" text-10px font-normal text-mute ">Thursday</p>
          </div>
        </b-card>
      </div>
    </div>

    <!-- <p class="font-bold text-sm text-black mb-2 pl-1 mt-auto">
      + Add new block
    </p> -->
  </b-card>
</template>
<script>
import "@/views/admin/scss/Index.scss";
export default {
  data() {
    return {};
  }
};
</script>
